<div class="top-bar">
  <div class="row mx-0 mb-md-4" *ngIf="!titleTranslationCode">
    <div class="col">
      <button
        *ngIf="isBackButtonShown"
        type="button"
        class="btn btn-outline-secondary rounded-pill btn-back btn-back-size"
        [routerLink]="backButtonRouterLink"
        (click)="onBackButtonClick($event)"
        >
          <app-icon name="arrow-back"></app-icon>
          <span class="d-none d-lg-block ms-3">
            {{ backButtonText }}
          </span>
      </button>
    </div>
    <ng-content select="[nav-title]">
    </ng-content>
    <app-top-bar-user-menu class="col"></app-top-bar-user-menu>
  </div>
  <ng-content select="[details]">
  </ng-content>
  <ng-content select="[content]">
  </ng-content>
  <ng-container *ngIf="titleTranslationCode">
    <content class="mb-md-4" id="top-bar-content">
      <div class="col">
        <button
        *ngIf="redirectTranslationCode && !isHighestLevel()"
        type="button"
        class="btn btn-outline-secondary rounded-pill btn-back btn-back-size"
        [routerLink]="redirectLink"
        >
          <app-icon name="arrow-back"></app-icon>
          <span class="d-none d-lg-block ms-3"
            [translate]="redirectTranslationCode">
          </span>
        </button>
      </div>
      <div class="text-center col">
        <h4 [translate]="titleTranslationCode"></h4>
      </div>
      <app-top-bar-user-menu class="col"></app-top-bar-user-menu>
    </content>
  </ng-container>
  <ng-content select="footer"></ng-content>
</div>
